export default __webpack_public_path__ + "static/media/magneticlock.168d029e.jpg";